import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";

const blogCards = [
  {
    slug: "hotel-laundry-outsourcing-london",
    category: "Hotel Laundry",
    title: "Why More Hotels Are Outsourcing Guest & Staff Laundry",
    summary:
      "Running in-house laundry costs more than most hotels realise. We look at why more properties around ExCeL London are switching to a same-day specialist partner — and what they gain in quality, speed and cost.",
    date: "2025-07-01",
  },
  {
    slug: "professional-garment-care-guide",
    category: "Garment Care",
    title: "The Ultimate Guide to Professional Garment Care",
    summary:
      "A well-made garment is an investment. This guide covers why dry cleaning isn't just for special occasions, how different fabrics should be treated, and the simple habits that extend the life of your wardrobe.",
    date: "2025-07-01",
  },
  {
    slug: "commercial-cleaning-services-london",
    category: "Commercial Laundry",
    title: "Commercial Laundry & Dry Cleaning Services for Businesses",
    summary:
      "Hotels, offices, restaurants and healthcare businesses across London rely on a specialist partner to handle laundry at scale. Here's what a good commercial service looks like and what to expect from same-day collection.",
    date: "2025-07-01",
  },
];

function formatDate(iso: string) {
  return new Date(iso).toLocaleDateString("en-GB", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });
}

function BlogListPage() {
  useEffect(() => {
    const defaultTitle = "Laundry & Dry Cleaning Blog | Xcel Dry Cleaners London";
    const defaultDesc =
      "Expert articles on hotel laundry outsourcing, professional garment care and commercial cleaning services from Xcel Dry Cleaners London.";
    document.title = defaultTitle;
    document.getElementById("title")?.setAttribute("content", defaultTitle);
    document.getElementById("description")?.setAttribute("content", defaultDesc);

    const base_url = process.env.REACT_APP_BACKEND_URL;
    if (base_url) {
      axios({
        method: "post",
        url: `${base_url}/api/get_meta_tags`,
        data: { url: window.location.pathname.length > 1 ? window.location.pathname.replace(/\/+$/, "") : window.location.pathname },
        headers: { Accept: "application/json", "Access-Control-Allow-Methods": "GET, POST" },
      })
        .then((response: any) => {
          if (
            response &&
            response.data &&
            response.data.Response &&
            response.data.Response.response_code !== "-1" &&
            response.data.data
          ) {
            const metaTitle = response.data.data.meta_title || defaultTitle;
            const metaDescription = response.data.data.meta_description || defaultDesc;
            document.title = metaTitle;
            document.getElementById("title")?.setAttribute("content", metaTitle);
            document.getElementById("description")?.setAttribute("content", metaDescription);
          }
        })
        .catch(() => {});
    }
  }, []);

  return (
    <>
      <div className="xcel-page-hero">
        <div className="container">
          <nav className="xcel-breadcrumb" aria-label="breadcrumb">
            <a href="/">Home</a>
            <span aria-hidden="true"> / </span>
            <span aria-current="page">Blog</span>
          </nav>
          <h1>Laundry &amp; Dry Cleaning Blog</h1>
          <p className="xcel-page-hero-meta">
            Expert advice from Xcel Dry Cleaners London
          </p>
        </div>
      </div>

      <div className="xcel-cs-list-page">
        <div className="container">
          <p className="xcel-cs-list-intro">
            Practical guides on hotel laundry outsourcing, professional garment
            care and commercial cleaning — written by the team at Xcel Dry
            Cleaners, who handle same-day laundry for hotels around ExCeL London
            every day.
          </p>

          <div className="xcel-cs-list-grid">
            {blogCards.map((post) => (
              <Link
                key={post.slug}
                to={`/blog/${post.slug}`}
                className="xcel-cs-card"
              >
                <span className="xcel-cs-card-tag">{post.category}</span>
                <h2 className="xcel-cs-card-hotel">{post.title}</h2>
                <p className="xcel-cs-card-summary">{post.summary}</p>
                <span className="xcel-cs-card-date">
                  {formatDate(post.date)}
                </span>
                <span className="xcel-cs-card-read-more">Read article →</span>
              </Link>
            ))}
          </div>

          <div className="xcel-cta-banner" style={{ marginTop: "56px" }}>
            <h3>
              Looking for a reliable laundry partner in London? Contact Xcel
              Dry Cleaners to discuss same-day collection for your hotel or
              business.
            </h3>
            <Link to="/Contactus" className="xcel-cta-btn">
              Contact Us
            </Link>
          </div>
        </div>
      </div>

      <div className="xcel-blog-links-strip">
        <div className="container text-center">
          <p className="mb-2">
            <strong>Read our hotel partnership case studies</strong>
          </p>
          <div className="xcel-blog-strip-links">
            <Link to="/case-studies/novotel-london-excel-laundry-partnership">
              Novotel London Excel
            </Link>
            <Link to="/case-studies/crowne-plaza-london-docklands-laundry-partnership">
              Crowne Plaza London Docklands
            </Link>
            <Link to="/case-studies/ibis-london-excel-docklands-laundry-partnership">
              ibis London Excel Docklands
            </Link>
          </div>
        </div>
      </div>
    </>
  );
}

export default BlogListPage;
